import React from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';

import {headOption} from 'utils/common';

import {SplitAvatarUpload} from 'components/AvatarUpload';

import {userProfileRequest, selectCurrentUser} from 'ducks/auth';
import {verifyUserInternalAvatarUpload} from 'ducks/users';
import {uploadFile} from 'ducks/files';
import {delayedAction, composeActions} from 'ducks/common';
import {fetchStaffMembers} from 'ducks/teams';

import {signUserInternalAvatar} from 'sdk/users';

import './styles.css';

// This delay is needed because the call to S3 is slower than the fetch we make again
const REFETCH_AVATARS_DELAY = 500;

class UserSection extends React.Component<any> {
  state = {
    wrongFormat: false
  };

  onFileDrop = files => {
    if (_.isEmpty(files)) {
      return this.setState({wrongFormat: true});
    }

    const {user} = this.props;
    const file = headOption(files);
    const signData = {
      filename: file.name,
      fileType: file.type,
      userId: user.id
    };

    const finishUploadingAction = () =>
      delayedAction({
        delay: REFETCH_AVATARS_DELAY,
        action: () =>
          composeActions([
            () => userProfileRequest(),
            () => fetchStaffMembers()
          ])
      });

    const storeIdentifierAction = identifier =>
      verifyUserInternalAvatarUpload({identifier, userId: user.id});

    this.setState({wrongFormat: false}, () =>
      this.props.uploadFile({
        file,
        signSdk: signUserInternalAvatar,
        signData,
        finishUploadingAction,
        storeIdentifierAction
      })
    );
  };

  render() {
    const {user} = this.props;
    const {wrongFormat} = this.state;
    return (
      <div className="UserSection">
        <SplitAvatarUpload
          user={user}
          onFileDrop={this.onFileDrop}
          wrongFormat={wrongFormat}
        />
        <div className="info">
          <div className="name">{user.fullName}</div>
          <div className="jobTitle">{user.jobTitle}</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({user: selectCurrentUser(state)});
const mapDispatchToProps = {uploadFile};

export default connect(mapStateToProps, mapDispatchToProps)(UserSection);
